export enum RequestAttributeType {
  HEADER = 'HEADER',
  PARAM = 'PARAM',
  PATH_VARIABLE = 'PATH_VARIABLE',
  BODY_ENTRY_FORM_URLENCODED = 'BODY_ENTRY_FORM_URLENCODED',
}
